define('shared/initializer/tracking',[
    '$',
    'shared/util/state',
    'shared/util/hub',
    'shared/lib/RSVP',
    'shared/util/state/adapters/form',
    'shared/util/state/adapters/order',
    'shared/util/state/adapters/pending',
    'shared/lib/console',
    'shared/lib/cookie',
    'shared/lib/URI',
    'shared/initializer/form/constants',
    'shared/util/checkout/checkout'
],
function (
    $,
    state,
    hub,
    RSVP,
    formAdapter,
    orderAdapter,
    pendingAdapter,
    console,
    cookie,
    URI,
    constants,
    checkoutUtil
) {
    'use strict';

    var g = this;
    var LOG_NAME = '%c Tracking Initializer: ';
    var logStyle = 'background: #666; color: #FFF;';
    var inited;

    return {
        init: function(){
            if ( inited ) {
                return inited;
            }
            var flowType;

            var ret = RSVP.resolve()
                .then(function(){
                    console.log(LOG_NAME, logStyle, 'Adding adapters...');
                    return state.adapters.add(formAdapter);
                })
                .then(function(){
                    return state.adapters.add(orderAdapter);
                })
                // Task: collect tracking events starts
                .then(function(){
                    console.log(LOG_NAME, logStyle, 'adapters added, update tracking.events...');
                })
                .then(function(){
                    return state.adapters.add(pendingAdapter);
                })
                .then(function(){
                    return state.get(constants.State.TrackingEvents, constants.State.TrackingPendingEvents);
                })
                .then(function(values){
                    var events = values[0] || [];
                    var pendings = values[1] || [];

                    events = events.concat(pendings);
                    var l;

                    // de-duplicate
                    var tmp = {};
                    for(l = events.length; l--;) {
                        tmp[events[l]] = true;
                    }

                    events = [];

                    for(var key in tmp) {
                        if (!tmp.hasOwnProperty(key)) {
                            continue;
                        }

                        events.push(key);
                    }

                    return state.push(constants.State.TrackingEvents, events);
                })
                .then(function(){
                    // clear pending events
                    return state.push(constants.State.TrackingPendingEvents, []);
                })
                .then(function(){
                    console.log(LOG_NAME, logStyle, 'tracking.events updated');
                })
                .then(function(){
                    return checkoutUtil.getCurrentFlowType();
                })
                .then(function(type){
                    flowType = type;
                })
                .then(function(){
                    return state.push(constants.State.TrackingCheckoutFlowType, flowType);
                })
                // Task: collect tracking events finished
                .then(function(){
                    console.log(LOG_NAME, logStyle, 'Waiting for blocker to be unblocked');
                    return hub.peek('kernel/blocker/tracking/blocking/promise');
                })
                .then(function(){
                    return state.push('page.geo_located_ctr', cookie.get('ipctr'));
                })
                .then(function(){
                    console.log(LOG_NAME, logStyle, 'Blocker unblocked.');

                    $(function(){
                        console.log(LOG_NAME, logStyle, 'firing et.tracking...');
                        if (g.et && g.et.tracking) {
                            g.et.tracking.pageload();
                        }

                        if (window.dataLayer) {
                            window.dataLayer.push({'event': 'gtmDatalayerInit'});
                        } else if (console) {
                            (console.error || console.log)('GTM object not available');
                        }

                        console.log(LOG_NAME, logStyle, 'et.tracking fired');
                    });
                });

            inited = ret;

            return ret;

        }
    };
});

